import React, { Component, useCallback } from "react";
import { withRouter } from "react-router-dom";
import { debounce } from "lodash";
import { Card, Alert, Icon, Tooltip, Typography, Form } from "antd";
import { MdHourglassEmpty } from "react-icons/md";
import "./FinalView.css";
import { render } from "react-dom";
import { connect } from "react-redux";
import { Select, Tag, Col, Row, Spin } from "antd";
import PopUp from "./PopUp";
import PickupDeliveryFactory from "./PickupDeliveryFactory";
// import ExistingFactoryDescForm from '../../form-section/ExistingFactoryDescForm';
import ExistingFactoryDescForm from "./ExistingFactoryDescForm";
import PopUpForFactory from "./PopUpForFactory";
import * as actions from "../../actions";
import { Create_New_Booking } from "../../actions";
import ScheduleTimeline from "../result-section/finalResultCard/ScheduleTimeline";
import CreatableSelect from "react-select/creatable";
import { getPoNumberBySearch, addPurchaseOrder, searchPOs, getSelectedCustomBroker, getAllCustomBroker } from "../../GraphQL/entities";
import TransparentOverlay from "./TransparentOverlay";
import DutyAndTax from "../booking/DutyAndTax";
import { calculateDutyTaxFee, getInsuranceChargeForCommodities } from "../../util/getBookingInfo";
import CargoInsurance from "../booking/CargoInsurance";
// TODO : test for difference
const { Option } = Select;
const createOption = (label, id, styleNumber) => ({
  label,
  value: label.replace(/\W/g, ""),
  id,
  styleNumber,
});

// Custom loading indicator component
const LoadingIndicator = () => (
  <div style={{ display: 'flex', justifyContent: 'center', padding: '10px', minHeight:'100px' }}>
    <Spin style={{
            margin: 'auto'
        }}
        indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}
    />
  </div>
);

class StartCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      carrier: "Carrier Name",
      rate: "Rate",
      vesselService: "Vessel Service",
      etdOrigin: new Date(),
      pickUpChange: false,
      deliveryChange: false,
      newPickup: false,
      newDelivery: false,
      poNumbers: [],
      currentPoNumber: "",
      ShowPopUp: false,
      ShowPopUpShipperForm: false,
      ShowPopUpDeliveryForm: false,
      form: {},
      selectedPos: [],
      isLoading: false,
      customBroker:[],
      loadingBrokers: false,
      selectedBroker: null,
      brokerageFee:0,
      AgentProfileInfo:null,
      insuredValue:'',
      insuranceFee:0,
      showDutyAndTax: false,
      commodity:{},
      commodityArr:[{}],
      dutyTax: [{}],
      dutyTax_amount_subtotal: {
        duties: 0,
        taxes: 0,
    }, // State to store dutyTax_amount_subtotal
    };

    this.fetchOptions = debounce(this.fetchOptions.bind(this), 300);
  }
  handleDutyTaxChange = (index, key, value) => {
    const { dutyTax } = this.state;
    dutyTax[index][key] = value; // Update the value of the specified key in the reference object
    this.setState({ dutyTax });
  };

  handleAddDutyTax = () => {
      const { dutyTax } = this.state;
      this.setState({
          dutyTax: [...dutyTax, {
              amount: '',
              description: '',
              quantity: '',
              hs_code: '',
          }],
      });
  };

  handleDeleteDutyTax = index => {
      const { dutyTax } = this.state;
      let dutyTaxFiltered = dutyTax.filter((_, idx) => idx !== index);
      // console.log("dutyTax: ",dutyTaxFiltered)
      this.setState({
          dutyTax: dutyTaxFiltered,
      });
      this.props.form.setFieldsValue({ dutyTax: dutyTaxFiltered });
  };

  handleAddCommodity = () => {
    const { commodityArr } = this.state;
    this.setState({
        commodityArr: [...commodityArr, {
            category: '',
            description: '',
            commodityValue: '',
        }],
    });
  };

  handleDeleteCommodity = index => {
      const { commodityArr } = this.state;
      let commodityFiltered = commodityArr.filter((_, idx) => idx !== index);
      console.log("--commodityFiltered---: ",commodityFiltered)
      this.setState({
          commodityArr: commodityFiltered,
      });
      // this.props.form.setFieldsValue({ commodityArr: commodityFiltered });
  };


  handleCommodityChange = (index, key, value) => {
      const { commodityArr } = this.state;
      commodityArr[index][key] = value; // Update the value of the specified key in the reference object
      this.setState({ commodityArr });
  };

  handleInsuranceAmountChange = (insurance) => {
    this.setState({ insuranceArr: insurance });
  };

  calculateTotalPrice = () => {
      let total = 0;
      let insuranceFee = 0;
      const shippingCost = parseFloat(this.props?.final_search_form?.selected_card_json?.bookNowPrice);
      const brokerageFee = parseFloat(this.state.brokerageFee);
      const {duties, taxes} = this.state.dutyTax_amount_subtotal;
      const duty = duties? Number(duties) : 0
      const tax = taxes ? Number(taxes) : 0

      if (this.state?.insuranceArr && this.state.insuranceArr.length > 0) {
        insuranceFee = this.state.insuranceArr?.reduce((sum, item) => {
            const premiumAmount = Number(item.quote?.premium_amount) || 0;
            return sum + (isNaN(premiumAmount) ? 0 : premiumAmount);
        }, 0);
      }
      // console.log("insurance fee: ",insuranceFee)
      total = (shippingCost + insuranceFee + brokerageFee + duty + tax).toFixed(2);
    
      return total;
  }

  // Event handler to update dutyTax_amount_subtotal state
  handleDutyTaxAmountSubtotalChange = (amountSubtotal) => {
      this.setState({ dutyTax_amount_subtotal: {duties: amountSubtotal?.Duty, taxes: amountSubtotal?.VAT} });
  };

  fetchBrokers = async () =>{
      try {
          this.setState({ loadingBrokers: true });
          const result = await getSelectedCustomBroker(this.props.jwt_token,this.props.user.id)
          if(result && result?.[0] && result[0]){
              const preSelectedBroker = result[1]
              const selectedCustomBroker = preSelectedBroker && preSelectedBroker?.[0]?.customBroker
              // console.log("selectedBroker: ",preSelectedBroker,selectedCustomBroker)
              this.setState({
                  selectedBroker: {
                    id: selectedCustomBroker.id,
                    companyName: selectedCustomBroker.companyName,
                  },
                });
          }
          const response = await getAllCustomBroker(this.props.jwt_token)
          const brokerData = response && response[1]
          this.setState({ customBroker:brokerData, loadingBrokers: false });
        } catch (error) {
          console.error('Error fetching brokers:', error);
          this.setState({ loadingBrokers: false });
        }
  }

  fetchAgents = async () => {
    const { user, verification } = this.props.initAuth;
    const isUserPresent = !!(user && verification);
    try {
        const response = await this.props.getAllAgentProfiles(isUserPresent);
        const agentProfiles = response && response[1]
        const countryId = this.props.queryParams?.from?.countryId;
        
        if(agentProfiles && countryId && agentProfiles.length > 0){
           
            const agentInfo = agentProfiles.find(profile => profile.country_entity && profile.country_entity.id === countryId);
            const agentProfile = agentInfo || null
            
            this.setState({AgentProfileInfo: agentProfile});
        }
    }
    catch (error) {
        console.error('Error fetching agents:', error);
    }
  };

  componentDidMount() {
    this.setState({ isLoading: true });
    this.fetchBrokers();
    this.fetchAgents();
    // Simulate API call to fetch default options
    getPoNumberBySearch(this.props.jwt_token)
      .then((allPoNumbers) => {
        //this.setState({ poNumbers: allPoNumbers });
        const formattedOptions = allPoNumbers?.map((option) =>
          createOption(option.orderNumbers, option.id, option.styleNumber)
        );
        this.setState({ poNumbers: formattedOptions, isLoading: false });
      })
      .catch((error) => {
        console.error("Error fetching default options:", error);
        this.setState({ isLoading: false });
      });
  }
  onFactoryDataChange = () => {
    this.setState({ newPickup: false });
    this.setState({ pickUpChange: true });
    this.setState({ ShowPopUp: false });
  };

  onFactoryDeliveryChange = () => {
    this.setState({ deliveryChange: true });
    this.setState({ newDelivery: false });
  };

  ChaneNewPickFactoryToTrue = () => {
    this.setState({ newPickup: true });
    this.setState({ pickUpChange: false });
  };

  ChaneNewDeliveryFactoryToTrue = () => {
    this.setState({ newDelivery: true });
    this.setState({ deliveryChange: false });
  };

  handleSaveDetails = () => {
    this.setState({ newPickup: false });
    this.setState({ ShowPopUp: false });
    this.setState({ ShowPopUpShipperForm: false });
    this.setState({ ShowPopUpDeliveryForm: false });
    this.setState({ newDelivery: false });
  };

  handleCustomBrokerChnage = (value) =>{
    const selectedBroker = this.state.customBroker.find(broker => broker.companyName === value);
    if (selectedBroker) {
    this.setState({
        selectedBroker: {
        id: selectedBroker.id,
        companyName: selectedBroker.companyName,
        },
      });
    }
  }

  validateShipperInfo = () => {
    const { isExistingPickupFactorySelected } = this.props;
    if(Object.keys(isExistingPickupFactorySelected).length >0 ){
        this.setState({ ShowPopUp: false });
        return true;
    }else{
        this.setState({ ShowPopUp: true });
        return false;
    }
};

  handleCreateBooking = async () => {
    const {
      isExistingPickupFactorySelected,
      isExistingDeliveryFactorySelected,
    } = this.props;

    // Validate shipper information
    if (!this.validateShipperInfo()
    ) {
        // Stop the booking creation process if validation fails
        return;
    }
    const selectedPoNumbers = [];
    let styleNumbers = "";

    if (
      this.state.selectedPos &&
      Array.isArray(this.state.selectedPos) &&
      this.state.selectedPos.length > 0
    ) {
      this.state.selectedPos.map((item) => selectedPoNumbers.push(item.id));
      // Join style numbers if they are not null or empty
      styleNumbers = this.state.selectedPos
        .filter(
          (item) => item && item.styleNumber && item.styleNumber.trim() !== ""
        )
        .map((item) => item.styleNumber)
        .join(", ");
    }

    if (Object.keys(isExistingPickupFactorySelected).length > 0) {
      const delivery_selected_index =
        this.props.final_search_form.selected_card_detail
          .delivery_selected_option_index;
      const pickup_selected_index =
        this.props.final_search_form.selected_card_detail
          .pickup_selected_option_index;
      let bookingObject = {
        carrier: this.props?.final_search_form?.selected_card_json?.carrier?.id,
        charge_id: this.props?.final_search_form?.selected_card_json?.charge_id,
        charge_type_id:
          this.props?.final_search_form?.selected_card_json?.charge_type_id,
        container_type: this.props?.final_search_form.type?.includes("fcl")
          ? "FCL"
          : "LCL",
        vessel_service:
          this.props?.final_search_form?.selected_card_json?.vessel_Service.id,
        ETD_origin:
          this.props?.final_search_form?.selected_card_json?.etd_origin,
        rate: this.props?.final_search_form?.selected_card_detail?.bookNowPrice,
        origin_port: this.props?.queryParams?.from?.id,
        discharge_port:
          this.props?.final_search_form?.selected_card_json?.port_of_discharge
            ?.id,
        destination_port: this.props?.queryParams?.to?.id,
        agent_info: this.props?.AgentInformation?.id,
        shipper_info: isExistingPickupFactorySelected?.id,
        delivery_location: isExistingDeliveryFactorySelected?.id,
        isPickupChecked:
          this.props?.final_search_form?.selected_card_detail?.pickup_isChecked,
        isPortOriginChecked:
          this.props?.final_search_form?.selected_card_detail?.origin_isChecked,
        isFreightChecked:
          this.props?.final_search_form?.selected_card_detail
            ?.frieght_isChecked,
        isDischargeChecked:
          this.props?.final_search_form?.selected_card_detail
            ?.discharge_isChecked,
        isErsChecked:
          this.props?.final_search_form?.selected_card_detail?.ers_isChecked,
        isDeliveryChecked:
          this.props?.final_search_form?.selected_card_detail
            ?.delivery_isChecked,
        validity_from:
          this.props?.final_search_form?.selected_card_json?.valid_date_from,
        validity_to:
          this.props?.final_search_form?.selected_card_json?.valid_date_to,
        vendor_contract:
          this.props?.final_search_form?.selected_card_json?.vendor_contract
            ?.id,
        mode_of_transport:
          this.props?.final_search_form?.selected_card_json?.mode,
        schedule_id:
          this.props?.final_search_form?.selected_card_detail?.selectedSchedule
            ?.id,
        custom_broker: this.state?.selectedBroker?.id,
        consignee_role:this.props.transaction_type,
        agentProfileID: this.state?.AgentProfileInfo?.id,
        insuredValue: Number(
          (this.state.insuranceArr?.reduce((sum, item) => {
              // console.log("---commodity_value---", item.commodity_value);
              const value = Number(item.commodity_value);
              return sum + (isNaN(value) ? 0 : value);
          }, 0) || 0).toFixed(2)
        ),
        insuranceFee: Number((this.state.insuranceArr?.reduce((sum, item) => {
            return sum + Number(item?.quote?.premium_amount);
        }, 0) || 0).toFixed(2)),
      };

      if (this.props.final_search_form.type === "api-lcl") {
        bookingObject = {
          ...bookingObject,
          chargeable_weight: this.props?.final_search_form?.chargeableWeight,
          container_type: "LCL",
          freight_rate: Number(this.props?.final_search_form?.freightRate),
        };
      } else if (this.props.final_search_form.type === "api-fcl") {
        bookingObject = {
          ...bookingObject,
          _20stCounter: this.props?.final_search_form?.container?._20stCounter,
          _40hqCounter: this.props?.final_search_form?.container?._40hqCounter,
          _40stCounter: this.props?.final_search_form?.container?._40stCounter,
          _45hqCounter: this.props?.final_search_form?.container?._45hqCounter,
          _20stPrice:
            this.props.discount && this.props.discount.id
              ? this.props?.final_search_form?.selected_card_detail?._20stPrice
              : Number(
                  this.props?.final_search_form?.selected_card_json?.["20st"]
                ),
          _40hqPrice:
            this.props.discount && this.props.discount.id
              ? this.props?.final_search_form?.selected_card_detail?._40hqPrice
              : Number(
                  this.props?.final_search_form?.selected_card_json?.["40hq"]
                ),
          _40stPrice:
            this.props.discount && this.props.discount.id
              ? this.props?.final_search_form?.selected_card_detail?._40stPrice
              : Number(
                  this.props?.final_search_form?.selected_card_json?.["40st"]
                ),
          _45hqPrice:
            this.props.discount && this.props.discount.id
              ? this.props?.final_search_form?.selected_card_detail?._45hqPrice
              : Number(
                  this.props?.final_search_form?.selected_card_json?.["45hq"]
                ),
          container_type: "FCL",
        };
      }
      const pickup_charges =
        this.props?.final_search_form?.selected_card_json?.pickup_section?.[
          pickup_selected_index
        ] || {};
      const delivery_section =
        this.props?.final_search_form?.selected_card_json?.delivery_section?.[
          delivery_selected_index
        ] || {};

      let deliveryRateArr = [];
      if (
        delivery_section &&
        delivery_section.hasOwnProperty("rate") &&
        Array.isArray(delivery_section.rate)
      ) {
        deliveryRateArr =
          this.props?.final_search_form?.selected_card_detail?.delivery_charges;
      }

      let pickupRateArr = [];
      if (
        pickup_charges &&
        pickup_charges.hasOwnProperty("rate") &&
        Array.isArray(pickup_charges.rate)
      ) {
        pickupRateArr =
          this.props?.final_search_form?.selected_card_detail?.pickup_charges;
      }

      let booking_charges = {
        ers_section:
          this.props?.final_search_form?.selected_card_detail?.ers_charges,
        port_origin_section:
          this.props?.final_search_form?.selected_card_detail
            ?.port_fees_from_charges,
        port_discharge_section:
          this.props?.final_search_form?.selected_card_detail
            ?.port_fees_to_charges,
        pickup_section_charges: pickupRateArr,
        pickup_section: pickup_charges,
        delivery_section: delivery_section,
        delivery_section_charges: deliveryRateArr,
        discountID: this.props?.discount?.id,
        po_number: selectedPoNumbers,
        style_nuumbers: styleNumbers,
        insurances: this.state.insuranceArr
      };

      if(this.state.insuranceArr && (this.state.insuranceArr).length > 0){
        booking_charges = getInsuranceChargeForCommodities(this.state.insuranceArr, booking_charges);
      }

      if(this.state.dutyTax_amount_subtotal && Object.keys(this.state.dutyTax_amount_subtotal).length > 0){
        const totalDutyTaxAmount = parseFloat(this.state.dutyTax_amount_subtotal.duties + this.state.dutyTax_amount_subtotal.taxes);
        if(totalDutyTaxAmount && totalDutyTaxAmount > 0){
            booking_charges = calculateDutyTaxFee(totalDutyTaxAmount, booking_charges);
        }
      }
      const result = await this.props.Create_New_Booking(
        bookingObject,
        booking_charges
      );
      if (result[0]) {
        this.props.final_booking_button({
          bookingSuccessful: true,
          bookingId: result[1],
        });
      } else {
        this.props.updateErrorAndLoading(
          "Error ! Please Contact Prime Freight",
          undefined
        );
      }
    } else {
      this.setState({ ShowPopUp: true });
      const form = {
        MessageType: "Error",
        MessageDescription: "Select Shipper first",
      };
      this.setState({ form: form });
    }
  };

  openPopUpFactory = () => {
    this.setState({ ShowPopUpShipperForm: true });
  };

  openPopUpFactoryDelivery = () => {
    this.setState({ ShowPopUpDeliveryForm: true });
  };

  closePopUp = () => {
    this.setState({ ShowPopUp: false });
  };

  handleGoBack = () => {
    this.props.final_submit_button(false);
    this.props.back_submit_button(true);
  };

  handleCreate = (inputValue) => {
    this.setState({ isLoading: true });
    setTimeout(() => {
      const newOption = createOption(inputValue);
      this.setState((prevState) => ({
        poNumbers: [...prevState.poNumbers, newOption],
        isLoading: false,
      }));

      let payload = {
        orderNumbers: newOption.value,
        orderPurchaser: {
          id: this.props.user.id,
        },
      };

      try {
        addPurchaseOrder(this.props.jwt_token, payload).then((result) => {
          if (result[0]) {
            newOption.id = result[1];
            this.setState((prevState) => ({
              selectedPos: [...prevState.selectedPos, newOption],
            }));
          }
        });
      } catch (error) {
        console.error("Error occurred while adding po :", error);
      }
    }, 1000);
  };

  async fetchOptions(inputValue) {
    if (!inputValue) return;

    const newOptions = await searchPOs(
      this.props.jwt_token,
      inputValue,
      this.props.user.id
    );
    const formattedOptions = newOptions.map((option) =>
      createOption(option.orderNumbers, option.id, option.styleNo)
    );

    this.setState({
      poNumbers: formattedOptions,
    });
  }

  handlePoInput = (inputValue) => {
    this.fetchOptions(inputValue);
  };

  render() {
    const { poNumbers, isLoading, selectedPos, customBroker,loadingBrokers, AgentProfileInfo } = this.state;
    const {
      final_search_form,
      isExistingPickupFactorySelected,
      isExistingDeliveryFactorySelected,
      AgentInformation,
      transaction_type,
      queryParams,
      commodityList
    } = this.props;

    const schedule = final_search_form?.selected_card_detail?.selectedSchedule;
    return (
      <>
        <div className="final-view-container">
          <div className="no-result testR1">
            <Card style={{ height: "100%" }} className="no-result-card testR1">
              <div>
                <button className="back-btn" onClick={this.handleGoBack}>
                  Back
                </button>
              </div>
              <div className="view_header" style={{borderBottom: '0px'}}>Review Details</div>
              <Card title="Booking Details" //bordered={false}
               style={{ width: "auto" }} className='no-padding'>
              <div className="parent_grid">
                <div className="child_grid">
                  <div className="details_grid_not_mutable">
                    <div className="details_grid_not_mutable_div">
                      <div className="details_grid_not_mutable_div_heading">
                        Carrier:
                      </div>
                      <div className="details_grid_not_mutable_div_state">
                        {final_search_form.selected_card_json.sealine}
                      </div>
                    </div>
                    <div className="details_grid_not_mutable_div">
                      <div className="details_grid_not_mutable_div_heading">
                        Container Type:
                      </div>
                      <div className="details_grid_not_mutable_div_state">
                        {final_search_form.type.includes("fcl") ? "FCL" : "LCL"}
                      </div>
                    </div>
                    {final_search_form.container !== undefined && (
                      <div className="details_grid_not_mutable_div">
                        <div className="details_grid_not_mutable_div_heading">
                          Container Size:
                        </div>
                        <div className="details_grid_not_mutable_div_state">
                          {final_search_form.container._20stCounter > 0
                            ? `20 STD-${final_search_form.container._20stCounter}`
                            : ""}
                          {final_search_form.container._40stCounter > 0
                            ? ` 40 STD-${final_search_form.container._40stCounter}`
                            : ""}
                          {final_search_form.container._40hqCounter > 0
                            ? ` 40 HQ-${final_search_form.container._40hqCounter}`
                            : ""}
                          {final_search_form.container._45hqCounter > 0
                            ? ` 45 STD-${final_search_form.container._45hqCounter}`
                            : ""}
                        </div>
                      </div>
                    )}

                    {final_search_form.total_shipment !== undefined && (
                      <div className="details_grid_not_mutable_div">
                        <div className="details_grid_not_mutable_div_heading">
                          Total CBM And Weight:
                        </div>
                        <div className="details_grid_not_mutable_div_state">
                          {final_search_form.total_shipment.totalVolume} CBM ,{" "}
                          {final_search_form.total_shipment.totalWeight}{" "}
                          {final_search_form.total_shipment.weightUnit}
                        </div>
                      </div>
                    )}

                    <div className="details_grid_not_mutable_div">
                      <div className="details_grid_not_mutable_div_heading">
                        Vessel Service:
                      </div>
                      <div className="details_grid_not_mutable_div_state">
                        {final_search_form.selected_card_json.vesselService !==
                        null
                          ? final_search_form.selected_card_json.vessel_Service
                              .name
                          : "Prime Freight Service"}

                        {/*{final_search_form.selected_card_json.vesselService!==undefined?({final_search_form.selected_card_json.vessel_Service.name}):"Prime Freight Service"}*/}
                      </div>
                    </div>
                    <div className="details_grid_not_mutable_div">
                      <div className="details_grid_not_mutable_div_heading">
                        ETD Origin:
                      </div>
                      <div className="details_grid_not_mutable_div_state">
                        {final_search_form.selected_card_json.etd_origin}
                      </div>
                    </div>
                    <div className="details_grid_not_mutable_div">
                      <div className="details_grid_not_mutable_div_heading">
                        Origin Port:
                      </div>
                      <div className="details_grid_not_mutable_div_state">
                        {final_search_form.selected_card_json.port_of_origin}
                      </div>
                    </div>
                    <div className="details_grid_not_mutable_div">
                      <div className="details_grid_not_mutable_div_heading">
                        Discharge Port:
                      </div>
                      <div className="details_grid_not_mutable_div_state">
                        {
                          final_search_form.selected_card_json.port_of_discharge
                            .company_name
                        }
                      </div>
                    </div>
                    <div className="details_grid_not_mutable_div">
                      <div className="details_grid_not_mutable_div_heading">
                        Destination Port:
                      </div>
                      <div className="details_grid_not_mutable_div_state">
                        {final_search_form.selected_card_json.ers_location}
                      </div>
                    </div>
                    <div className="details_grid_not_mutable_div">
                      <div className="details_grid_not_mutable_div_heading">
                          Consignee Role:
                      </div>
                      <div className="details_grid_not_mutable_div_state">
                          {transaction_type}
                      </div>
                    </div>
                   
                    <div
                      className="details_grid_not_mutable_div"
                      style={{ border: "none" }}
                    >
                      <div className="details_grid_not_mutable_div_heading">
                        Agent Information:
                      </div>
                      <div className="details_grid_not_mutable_div_state">
                        { (AgentProfileInfo && AgentProfileInfo?.company_name)  ? AgentProfileInfo?.company_name : AgentInformation.name}
                      </div>
                    </div>
                    
                  </div>
                </div>
                <div className="child_grid">
                  <div className="details_grid_mutable">
                    <div className="details_grid_mutable_div">
                      <div className="input-heading-width">PO Number</div>
                      <div
                        className="input-container-width"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {/* <div style={{display: "flex", alignItems:"center",justifyContent:"center"}}> */}
                        <CreatableSelect
                          isClearable
                          isSearchable
                          isMulti
                          isDisabled={isLoading}
                          isLoading={isLoading}
                          onChange={(newValue) => {
                            this.setState({ selectedPos: [...newValue] });
                          }}
                          onCreateOption={this.handleCreate}
                          options={poNumbers}
                          value={selectedPos}
                          onInputChange={this.handlePoInput}
                          createOptionPosition="first"
                          className="factory-input-width"
                          formatCreateLabel={(inputValue) => (
                            <div style={{ fontWeight: "bolder" }}>
                              Add new PO "{inputValue}"
                            </div>
                          )}
                        />
                        {/* </div> */}
                      </div>
                    </div>

                    <div className="details_grid_mutable_div">
                      <div
                        className="input-heading-width" //style={{width:"30%"}}
                      >
                        <span style={{ display: "inline-block",
                            marginRight: "2px",
                            color: "#f5222d",
                            fontSize: "14px",
                            fontFamily: "SimSun, sans-serif",
                            lineHeight: 1, }}>*</span>
                        {transaction_type === 'Importer' ? (
                         "Shipper Information"
                        ) : (
                            "Pickup Location"
                        )}
                      </div>
                      <div
                        className="input-container-width" //style={{width:"70%"}}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <PickupDeliveryFactory
                            onFactoryDataChange={() =>
                              this.onFactoryDataChange()
                            }
                            isPickupFactory={true}
                            mode={"pickup"}
                            changeDrop={this.state.changeDropDown}
                            NewFactoryMode={() =>
                              this.ChaneNewPickFactoryToTrue()
                            }
                          />

                          {this.state.pickUpChange &&
                          Object.keys(isExistingPickupFactorySelected).length >
                            0 ? (
                            <div className="" style={{ textAlign: "center" }}>
                              <Tooltip placement="top" title="Edit Shipper">
                                <span onClick={() => this.openPopUpFactory()}>
                                  <Icon
                                    type="edit"
                                    theme="twoTone"
                                    style={{
                                      fontSize: "20px",
                                      marginLeft: 0,
                                      paddingLeft: "5px",
                                      alignSelf: "center",
                                      cursor: "pointer",
                                    }}
                                  />
                                </span>
                              </Tooltip>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                    {(this.state.newPickup ||
                      this.state.ShowPopUpShipperForm) && (
                      <PopUpForFactory
                        queryParams={queryParams}
                        selectedFactoryJson={isExistingPickupFactorySelected}
                        isPickupMode={true}
                        handleSaveDetails={() => this.handleSaveDetails()}
                        newFactory={this.state.newPickup}
                      />
                    )}
                    {this.state.ShowPopUp ? (
                      <div className="error-msg">
                      {transaction_type === 'Importer' ? 
                        "Please select shipper first!" :
                        "Please select pickup location first!"}
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="details_grid_mutable_div">
                      <div
                        className="input-heading-width" //style={{width:"30%"}}
                      >
                        {
                          transaction_type === 'Importer' ? "Delivery Location" : "Receiver Information"
                        }
                      </div>
                      <div
                        className="input-container-width" //style={{width:"70%"}}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <PickupDeliveryFactory
                            onFactoryDataChange={() =>
                              this.onFactoryDeliveryChange()
                            }
                            isPickupFactory={false}
                            mode={"pickup"}
                            changeDrop={this.state.changeDropDown}
                            NewFactoryMode={() =>
                              this.ChaneNewDeliveryFactoryToTrue()
                            }
                          />
                          {this.state.deliveryChange &&
                          Object.keys(isExistingDeliveryFactorySelected)
                            .length > 0 ? (
                            <div style={{ textAlign: "center" }}>
                              <Tooltip
                                placement="top"
                                title="Edit Delivery Location"
                                autoAdjustOverflow
                              >
                                <span
                                  onClick={() =>
                                    this.openPopUpFactoryDelivery()
                                  }
                                >
                                  <Icon
                                    type="edit"
                                    theme="twoTone"
                                    style={{
                                      fontSize: "20px",
                                      marginLeft: 0,
                                      paddingLeft: "5px",
                                      alignSelf: "center",
                                      cursor: "pointer",
                                    }}
                                  />
                                </span>
                              </Tooltip>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      {(this.state.newDelivery ||
                        this.state.ShowPopUpDeliveryForm) && (
                        <PopUpForFactory
                          queryParams={queryParams}
                          selectedFactoryJson={
                            isExistingDeliveryFactorySelected
                          }
                          isPickupMode={false}
                          handleSaveDetails={() => this.handleSaveDetails()}
                          newFactory={this.state.newDelivery}
                        />
                      )}
                    </div>
                    <div className="details_grid_mutable_div">
                      <div className="input-heading-width" //style={{width:"30%"}}
                      >
                          Custom Broker
                      </div>
                      <div className="input-container-width" //style={{width:"70%"}}
                      >
                          <div style={{display: "flex", alignItems:"center",justifyContent:"center"}}>
                          <Select
                              placeholder="Select a broker"
                              loading={loadingBrokers}
                              //value={this.state.selectedBroker}
                              value={this.state.selectedBroker ? this.state.selectedBroker.companyName : undefined}
                              className='factory-input-width'
                              onChange={this.handleCustomBrokerChnage}
                          >
                              {customBroker.map(broker => (
                              <Option key={broker.id} value={broker.companyName}>
                                  {broker.companyName}
                              </Option>
                              ))}
                          </Select>
                          </div>
                      </div>
                      </div>
                      {schedule && !schedule?.id && (
                        // Show the spinner until schedule.id is available
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '10px', minHeight:'50px' }}>
                          <Spin style={{
                                  margin: 'auto'
                              }}
                              indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}
                          />
                        </div>
                      )}
                      {schedule && schedule?.id && (
                        <div
                          style={{
                            //borderBottom: "1px solid #D2D2D2",
                            paddingBottom: "1rem",
                            color: "black"
                          }}
                        >
                          <Row style={{ padding: "1rem 0px 1rem 0" }}>
                            <Col xs={24} sm={12} style={{ paddingBottom: "1rem" }}>
                              <span>Schedule Voyage: {schedule?.voyage?.endsWith("-TBA") ? "TBA" : (schedule?.voyage)}</span>
                            </Col>
                            <Col xs={24} sm={12}  style={{ paddingBottom: "0" }}>
                              <div style={{ float: "left" }}>
                                <span
                                  //style={{ fontWeight: "600", fontSize: "12px" }}
                                >
                                  {
                                    (schedule?.transit_time) ? `Transit Time: ${schedule.transit_time} days`
                                    : ( ( schedule?.portTransitTime || schedule?.port_to_port_transit_time) && `Port Transit Time : ${schedule?.portTransitTime || schedule?.port_to_port_transit_time} days`)
                                  }
                                </span>
                              </div>
                            </Col>
                          </Row>
                          <div className="schedule-info-width">
                            <div style={{ paddingBottom: "3rem" }}>
                              <div>
                                Mother Vessel: {((schedule?.vesselName || schedule?.mother_vessel_name)?.endsWith("-TBA") ? "TBA" : schedule?.vesselName || schedule?.mother_vessel_name)}
                              </div>
                            </div>
                            <ScheduleTimeline schedule={schedule} />
                          </div>
                        </div>
                      )}
                      <div className="details_grid_not_mutable_div" style={{color:"black"}}>
                        <div className="details_grid_not_mutable_div_heading">
                            Total Shipping Cost:
                        </div>
                        <div className="details_grid_not_mutable_div_state">
                            {final_search_form.selected_card_detail.bookNowPrice}
                        </div>
                      </div>
                  
                 
                  </div>
                </div>
              </div>
              </Card>
              <Card title="Estimate Cargo Insurance"
                  style={{ width: 'auto', margin:'1rem 0' }} className='no-padding'>
                { (commodityList && commodityList.length >0) ?
                <div className="parent_grid">
                <div className="child_grid">
                    <div className="details_grid_not_mutable">
                          <CargoInsurance
                            //{...{ form: this.props.form }}
                            form={this.props.form} 
                            commodityArr = {this.state.commodityArr}
                            queryParams={this.props.queryParams}
                            final_search_form = {this.props.final_search_form}
                            jwt_token={this.props.jwt_token}
                            onInsuranceAmountChange={this.handleInsuranceAmountChange}
                            onCommodityChange={this.handleCommodityChange}
                            onAddCommodity={this.handleAddCommodity}
                            onDeleteCommodity={this.handleDeleteCommodity}
                        />
                    </div>
                </div>
                
                <div className="child_grid">
                    <div className="details_grid_not_mutable">
                    {this.state.insuranceArr && this.state.insuranceArr.length>0 &&
                            <div className="insurance_details">
                                {this.state?.insuranceArr?.map(item => {
                                    const description = item?.commodity_description;
                                    const premiumAmount = (item.quote && (item?.quote?.premium_amount !== null))
                                        ? (item?.quote?.premium_amount)
                                        : "-";
                                    //console.log("premium Amount: ",premiumAmount)
                                    //const policy = item?.policy_id

                                    return (
                                        <>
                                        <div className="details_grid_not_mutable_div">
                                                <div className="details_grid_not_mutable_div_heading">
                                                {description}
                                                </div>
                                                <div className="details_grid_not_mutable_div_state">
                                                    {`$ ${premiumAmount}`}
                                                </div>
                                        </div>
                                        </>
                                    );
                                })}
                            </div>
                        }

                        <div className="details_grid_not_mutable_div">
                                <div className="details_grid_not_mutable_div_heading">
                                Total Insurance Premium:
                                </div>
                                <div className="details_grid_not_mutable_div_state">
                                    {`$ ${(this.state?.insuranceArr?.reduce((sum, item) => {
                                            return sum + Number(item?.quote?.premium_amount);
                                        }, 0) || 0).toFixed(2)}`}
                                </div>
                        </div>
                        </div>
                    </div>
                </div>
                :
                <LoadingIndicator />
                }
              </Card>
              <Card title="Estimate Duty and Taxes" //bordered={false} 
                    style={{ width: 'auto', margin:'1rem 0' }} className='no-padding'>
                  <div style={{padding:"1rem"}}>
                      <div>
                          <DutyAndTax
                              {...{ form: this.props.form }}
                              dutyTax={this.state.dutyTax}
                              onDutyTaxChange={this.handleDutyTaxChange}
                              onAddDutyTax={this.handleAddDutyTax}
                              onDeleteDutyTax={this.handleDeleteDutyTax}
                              queryParams={this.props.queryParams}
                              final_search_form = {this.props.final_search_form}
                              jwt_token={this.props.jwt_token}
                              onDutyTaxAmountSubtotalChange={this.handleDutyTaxAmountSubtotalChange}
                          />
                      </div>
                      <div style={{paddingTop:"1rem"}}>
                          <div className="details_grid_not_mutable_div">
                                  <div className="details_grid_not_mutable_div_heading">
                                  Duties:
                                  </div>
                                  <div className="details_grid_not_mutable_div_state">
                                      {`$ ${this.state.dutyTax_amount_subtotal.duties || 0}`}
                                  </div>
                          </div>
                          <div className="details_grid_not_mutable_div">
                                  <div className="details_grid_not_mutable_div_heading">
                                  Taxes:
                                  </div>
                                  <div className="details_grid_not_mutable_div_state">
                                      {`$ ${this.state.dutyTax_amount_subtotal.taxes || 0}`}
                                  </div>
                          </div>
                          <div className="details_grid_not_mutable_div">
                                  <div className="details_grid_not_mutable_div_heading">
                                  <b> Total Price: </b>
                                  </div>
                                  <div className="details_grid_not_mutable_div_state">
                                      {`$ ${this.calculateTotalPrice()}`}
                                    
                                  </div>
                          </div>
                      </div>
                  </div>
              </Card>
              <div className="center-button">
                <button
                  className="create-booking-btn"
                  onClick={() => this.handleCreateBooking()}
                >
                  Create Booking
                </button>
              </div>
              {this.props.saveDataShowOverlay && (
                <TransparentOverlay message="Please wait..." />
              )}
            </Card>
          </div>
        </div>
      </>
    );
  }
}
const WrappedFinalView = Form.create({ name: 'booking-review' })(StartCard);
const mapStateToProps = (state) => {
  return {
    final_search_form: state.route.final_search_form,
    isExistingPickupFactorySelected:
      state.form.pickup.selectedExistingFactoryJson,
    isExistingDeliveryFactorySelected:
      state.form.delivery.selectedExistingFactoryJson,
    AgentInformation: state.form.AgentInformation,
    queryParams: state.route.queryParams,
    discount: state.route.discount,
    jwt_token: state.route.JWT_TOKEN.JWT_TOKEN,
    user: state.route.USER_DETAILS,
    saveDataShowOverlay: state.code_config.saveDataShowOverlay,
    transaction_type: state.code_config.transactionType,
    commodityList: state.route.commodityList,
    initAuth: state.code_config.initAuth,
  };
};

// final_search_form
// export default connect(mapStateToProps, actions)(StartCard);
export default withRouter(connect(mapStateToProps, actions)(WrappedFinalView));

// import React, {Component} from 'react';
// import './FinalView.css';
//
// class FinalView extends Component {
//     constructor(props) {
//         super(props);
//
//         this.state = {
//             carrier: 'Carrier Name', rate: 'Rate', vesselService: 'Vessel Service', etdOrigin: new Date(),
//         };
//     }
//
//     render() {
//         const {carrier, rate, vesselService, etdOrigin} = this.state;
//
//         return (<>
//                 <div className="setting_up_height_for_final_view">
//                     <div className="final-view-container">
//                         <div className="grid_view_for_selection">
//                             <div className="center-div">
//                                 <h1>Review Selected Details:</h1>
//                             </div>
//                             <div className="details-container">
//                                 <p><strong>Carrier:</strong> {carrier}</p>
//                                 <p><strong>Rate:</strong> {rate}</p>
//                                 <p><strong>Vessel Service:</strong> {vesselService}</p>
//                                 <p><strong>ETD Origin:</strong> {etdOrigin.toLocaleDateString()}</p>
//                                 {/* Add more properties as needed */}
//                             </div>
//                             <div className="price-container">
//                                 <h2>Total Price:</h2>
//                                 {/* Calculate and display total price based on rate */}
//                                 {/* Example: */}
//                                 <p className="total-price">Total Price: $500</p>
//                             </div>
//                             <div className="button-container">
//                                 <button className="create-booking-btn" onClick={this.handleCreateBooking}>
//                                     Create Booking
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </>
//
//         );
//     }
//
//     handleCreateBooking = () => {
//         // Logic for creating the booking
//     };
// }
//
// export default FinalView;
